export { default as authService } from "./auth.service";
export { default as authInterceptor } from "./auth-interceptor.service";
export { default as eventBus } from "./event-bus.service";
export { default as fileService } from "./file.service";
export { default as formService } from "./form.service";
export { default as httpClient } from "./http-client.service";
export { default as wsClient } from "./ws-client.service";
export { default as userService } from "./user.service";
export { default as chatService } from "./chat.service";
export { default as roleService } from "./role.service";
export { default as deviceService } from "./device.service";
export { default as regionService } from "./region.service";
export { default as vehicleService } from "./vehicle.service";
export { default as driverService } from "./driver.service";
export { default as siteService } from "./site.service";
export { default as tripService } from "./trip.service";
export { default as tripRouteService } from "./tripRoute.service";
export { default as salesdataService } from "./salesdata.service";
export { default as tripExceptionService } from "./tripException.service";
export { default as reportgenerationService } from "./reportgeneration.service";
export { default as firebaseService } from "./firebase.service";
export { default as schedulereportService } from "./schedulereport.service";
export { default as technicianService } from "./technician.service";
export { default as filterService } from "./filter.service";
// export { default as groupService } from './group.service'
export { default as permissionService } from "./permission.service";
// export { default as documentService } from './document.service'
// export { default as chatService } from './chat.service'
// export { default as statsService } from './stats.service'

export { default as staffService } from "./staff.service";
export { default as cityService } from "./city.service";
export { default as transportService } from "./transport.service";
export { default as segregationService } from "./segregation.service";
export { default as dumpyardService } from "./dumpyard.service";
export { default as wasteCollectionAreaService } from "./wasteCollectionArea.service";
export { default as vendorService } from "./vendor.service";
export { default as wasteTypeService } from "./wasteType.service";
export { default as helperAndDriverService } from "./helperanddriver.service";
export { default as primarytripService } from "./primarytrip.service";
export { default as secondaryTripService } from './secondaryTrip.service'
export { default as vehiclemaintenanceService } from "./vehiclemaintenance.service";
export { default as vehiclesService } from "./vehicles.service";
export { default as fuelexpensesService } from "./fuelexpenses.service";
export { default as wasterecycleService } from "./wasterecycle.service";
export { default as misCellaneousService } from "./misCellaneous.service";
export { default as dailyWagesService } from "./dailywages.service";
export { default as surveysService } from "./surveys.service";
export { default as exportcsvService } from "./exportcsv.service";
export { default as housesService } from "./houses.service";
export { default as transportPointTripService } from "./transportPointTrip.service";
export { default as wastesegregationservice } from "./wastesegregation.service";
export { default as dutyTrackingService } from "./tracking.service";
export { default as dashboardService } from "./dashboard.service";
export { default as reportsService } from "./reports.service";
export { default as syncWithTraccarService } from "./syncWithTraccar.service";



// WEBPACK FOOTER //
// ./src/services/index.js